module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.0b76df3.woff";